import React from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";

import "./i18n";
import App from "./App";
import { initSentry } from "./utils/sentry";

// Not awaited: the portal renders while the Sentry config loads.
initSentry();

const tagManagerArgs = {
  gtmId: "GTM-N6WV53J",
};

TagManager.initialize(tagManagerArgs);

createRoot(document.getElementById("root") as HTMLElement).render(<App />);
// test comment
